import { createStructureStatementHandler } from '../../createStructureStatementHandler';
import { getFormName } from '../../utils/nameFormat';
const optionsForm = getFormName('Option');
const productForm = getFormName('Product');
const variantForm = getFormName('Variant');
export const createInsideFormStmtInstruction = `
Use these commands instead of create scope when you want to add a new element within a repeater or select in a specific scope and view.

#### Add Repeater form
- Description: Adds a new element within a repeater in a specific scope and view, allowing for dynamic addition of complex nested elements. This command is designed to enhance the representation of user interfaces that require repetitive and variable user input structures.
- Syntax: \`add repeater form <repeater_element_name>-><inside_form_name> in <form_name>;\`
- Example: \`add repeater form options->${optionsForm} in ${productForm};\`
- Example: \`add repeater form variants->${variantForm} in ${productForm};\`

#### Add Select create form
- Description: Adds a create new form with element within a select in a specific scope and view, allowing for dynamic addition of complex nested elements. This command is designed to enhance the representation of user interfaces that require repetitive and variable user input structures.
- Syntax: \`add select form <select_element_name>-><inside_form_name> in <form_name>;\`
- Example: \`add select form options->${optionsForm} in ${productForm};\`
- Example: \`add select form variants->${variantForm} in ${productForm};\`
`;
/**
* Add repeater form <fieldName>-><insideFormName> in <formName>;
*
* @param fieldName
* @param insideFormName
* @param formName
 */
export const stmtCreateInsideRepeaterForm = ({ fieldName, insideFormName, formName }) => {
    return `add repeater form ${fieldName}->${insideFormName} in ${formName};`;
};
/**
 * Add select form <fieldName>-><insideFormName> in <formName>;
 *
 * @param fieldName
 * @param insideFormName
 * @param formName
 */
export const stmtCreateInsideSelectForm = ({ fieldName, insideFormName, formName }) => {
    return `add select form ${fieldName}->${insideFormName} in ${formName};`;
};
export const createInsideFormHandler = createStructureStatementHandler({
    type: 'add inside form',
    parse: line => {
        const match = /^add (repeater|select) form (?<fieldName>\w+)->(?<insideFormName>\w+) in (?<formName>\w+)/.exec(line);
        return match?.groups
            ? {
                type: 'add inside form',
                fieldName: match.groups.fieldName,
                formName: match.groups.formName,
                insideFormName: match.groups.insideFormName,
            }
            : null;
    },
    apply: (stmt, builder) => {
        builder.updateStructure(it => {
            return it.addCreateForm({ fieldName: stmt.fieldName, createFormName: stmt.insideFormName, formName: stmt.formName });
        });
    },
});
//# sourceMappingURL=CreateInsideFormStmt.js.map